import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _templateObject;
import React from 'react';
import { css, Global } from '@emotion/react';
import ReactDOM from 'react-dom';
import { notifyError } from '../Notification/NotificationHost';
import { overlayAnimationDurationMS, overlayFullAnimationDurationMS } from '../Overlay/Overlay.styled';
import { withTranslate } from '../util';
import { ErrorBoundary } from '../util/ErrorBoundary';
import { createPortal, destroyPortal, noPrintClassName } from '../util/renderPortal';
export function withModals(Component) {
  var _WithModals = /*#__PURE__*/function (_React$Component) {
    function WithModals() {
      var _this;
      _classCallCheck(this, WithModals);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, WithModals, [].concat(args));
      _defineProperty(_this, "nextModalId", 0);
      _defineProperty(_this, "fullscreenModals", new Set());
      _defineProperty(_this, "state", {
        modals: []
      });
      _defineProperty(_this, "setFullscreen", function (id) {
        _this.fullscreenModals.add(id);
      });
      _defineProperty(_this, "showModal", function (element) {
        var domNode = createPortal();
        var isClosing = false;
        var modal = {
          element: element,
          id: _this.nextModalId++,
          disposing: false,
          domNode: domNode,
          onDismiss: function onDismiss() {
            _this.disposeModal(modal);
            if (!isClosing && element.props.onDismiss) {
              isClosing = true;
              element.props.onDismiss();
            }
          },
          onCloseSuccess: function onCloseSuccess(value) {
            _this.disposeModal(modal);
            if (!isClosing && element.props.onCloseSuccess) {
              isClosing = true;
              element.props.onCloseSuccess(value);
            }
          }
        };
        _this.setState(function (state) {
          return {
            modals: [].concat(_toConsumableArray(state.modals), [modal])
          };
        });
      });
      _defineProperty(_this, "onError", function (modal) {
        var _modal$onDismiss;
        notifyError(_this.props.t('citrix-ui:generic_error_message'));
        (_modal$onDismiss = modal.onDismiss) === null || _modal$onDismiss === void 0 ? void 0 : _modal$onDismiss.call(modal);
      });
      _defineProperty(_this, "disposeModal", function (modal) {
        var currentModal = _this.state.modals.find(function (m) {
          return modal.id === m.id;
        });
        if (currentModal && currentModal.disposing) {
          return;
        }
        _this.setState(function (_ref) {
          var modals = _ref.modals;
          return {
            modals: modals.map(function (m) {
              return m === modal ? _objectSpread(_objectSpread({}, m), {}, {
                disposing: true
              }) : m;
            })
          };
        });
        var removalTimeout = _this.isFullScreen(modal) ? overlayFullAnimationDurationMS : overlayAnimationDurationMS;
        setTimeout(function () {
          var modalToRemove = _this.state.modals.find(function (m) {
            return m.id === modal.id;
          });
          if (!modalToRemove) {
            return;
          }
          _this.fullscreenModals["delete"](modalToRemove.id);
          _this.setState(function (_ref2) {
            var modals = _ref2.modals;
            return {
              modals: modals.filter(function (m) {
                return m !== modalToRemove;
              })
            };
          }, function () {
            return destroyPortal(modalToRemove.domNode);
          });
        }, removalTimeout);
      });
      return _this;
    }
    _inherits(WithModals, _React$Component);
    return _createClass(WithModals, [{
      key: "render",
      value: function render() {
        var _this2 = this;
        return /*#__PURE__*/React.createElement(React.Fragment, null, !!this.state.modals.length && /*#__PURE__*/React.createElement(Global, {
          styles: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\tbody {\n\t\t\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\t\t\t@media print {\n\t\t\t\t\t\t\t\t\t\toverflow: visible;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t.", " {\n\t\t\t\t\t\t\t\t\t@media print {\n\t\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t"])), noPrintClassName)
        }), /*#__PURE__*/React.createElement(Component, _extends({}, this.props, {
          showModal: this.showModal
        })), this.state.modals.map(function (modal) {
          var element = /*#__PURE__*/React.cloneElement(modal.element, {
            onDismiss: modal.onDismiss,
            onCloseSuccess: modal.onCloseSuccess,
            modalId: modal.id,
            setFullscreen: _this2.setFullscreen,
            isOpen: !modal.disposing
          });
          return /*#__PURE__*/React.createElement(ErrorBoundary, {
            onError: function onError() {
              return _this2.onError(modal);
            },
            key: modal.id.toString()
          }, /*#__PURE__*/ReactDOM.createPortal(element, modal.domNode, modal.id.toString()));
        }));
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.state.modals.forEach(function (modal) {
          destroyPortal(modal.domNode);
        });
      }
    }, {
      key: "isFullScreen",
      value: function isFullScreen(modal) {
        return this.fullscreenModals.has(modal.id);
      }
    }]);
  }(React.Component);
  return withTranslate(_WithModals);
}